import React from 'react';
import Page from '../Page';
import localized from '../../utils/Localization';
import EditableFavoritesItem from '../EditableFavoritesItem';
import Loader from '../Loader';
import { DatabaseInterface, Table } from '../../utils/Database/DatabaseInterface';

class Favourites extends DatabaseInterface {
	state = {
		list: [],
		stateUpdated: false
	}

	content = () => {
		if (this.state.stateUpdated) {
			if (this.state.list.length) {
				return (
					<div className="wrap">
						<ul className="stationslist">
							{
								this.state.list.map((station) => <EditableFavoritesItem station={station} layoutState={this.props.editFavoritesMode} fetchFavorites={this.fetchFavorites} key={station.id} />)
							}
						</ul>
					</div>
				);
			}

			return (
				<div className="wrap">
					<img src={require('../../assets/images/bigstar.svg').default} alt="Stations" />
					<p>{localized.noFavorites}</p>
				</div>
			);
		}

		return <Loader isLoading={true}></Loader>;
	}

	render() {
		return <Page to='/favourites' content={this.content(this)} {...this.props} />;
	}

	componentDidMount() {
		this.fetchFavorites();
	}

	fetchFavorites = () => {
		this.getSpecificData(Table.stationsTable, ['favorite'], [true])
			.then(aData => {
				this.handleListLoad(aData);
			});
	}

	handleListLoad = (list) => {
		this.setState({ stateUpdated: true, list: list || [] });

		this.props.setShowMenuButton(list && list.length);
	}
}

export default Favourites;
